import type { AriaAttributes } from 'react';

export function pickAriaProps<Props extends AriaAttributes>(
  props: Props,
): AriaAttributes {
  const ariaEntries = Object.entries(props).filter(([key]) =>
    key.startsWith('aria-'),
  );
  return Object.fromEntries(ariaEntries);
}
